import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ModifiersProvider } from 'contexts/Modifiers/ModifiersContext';
import { DayPickerProvider } from './DayPicker';
import { FocusProvider } from './Focus';
import { NavigationProvider } from './Navigation';
import { SelectMultipleProvider } from './SelectMultiple';
import { SelectRangeProvider } from './SelectRange';
import { SelectSingleProvider } from './SelectSingle';
/** Provide the value for all the context providers. */
export function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (_jsx(DayPickerProvider, __assign({ initialProps: initialProps }, { children: _jsx(NavigationProvider, { children: _jsx(SelectSingleProvider, __assign({ initialProps: initialProps }, { children: _jsx(SelectMultipleProvider, __assign({ initialProps: initialProps }, { children: _jsx(SelectRangeProvider, __assign({ initialProps: initialProps }, { children: _jsx(ModifiersProvider, { children: _jsx(FocusProvider, { children: children }) }) })) })) })) }) })));
}
//# sourceMappingURL=RootProvider.js.map